var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"box-shadow",attrs:{"href":"#","id":"btnTop"}},[_c('span',{staticClass:"arrow"})])}]

export { render, staticRenderFns }